import { ComponentLoadHelper } from '../../modules/component/componentLoadHelper';

const component = new ComponentLoadHelper({
  name: 'banner-hero',
  fileName: 'bannerHero',
});
component.register();
const c = () => import(
  /* webpackChunkName: "components/[request]" */
  `${component.path}/${component.fileName}`
);

component.loadElements(c);